// @flow

import React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import { Body } from 'components/Text';
import type { BlockquoteBlockData } from 'api/cms';
import { gutterWidth, colors } from '../../theme';

const BlockquoteBlock = styled(
  ({
    blockIndex,
    data: { quote, cite },
    className
  }: {
    blockIndex: number,
    data: BlockquoteBlockData,
    className: string
  }) => (
    <Box>
      <Box
        mx={[-gutterWidth / 2, null, -gutterWidth]}
        width={[
          `calc(100% + ${gutterWidth}px)`,
          null,
          `calc(100% + ${gutterWidth * 2}px)`
        ]}
        borderRadius={[0, 0, 0, 10]}
        bg={colors.fog}
        className={className}
      >
        <Box
          px={[gutterWidth / 2, null, gutterWidth]}
          py={60}
          textAlign="center"
        >
          <Body
            analyticsData={{
              eventName: 'CMS Block',
              eventProperties: {
                block_position: blockIndex,
                block_type: 'Block Quote'
              }
            }}
            styleAs={quote.length > 225 ? 'body' : 'bodyLarge'}
            dangerouslySetInnerHTML={{ __html: quote }}
          />
          {cite && (
            <Box mt="18px">
              <Body>{cite}</Body>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
)`
  position: relative;
  *:first-child {
    margin-top: 0;
  }
  *:last-child {
    margin-bottom: 0;
  }
  &::before {
    content: '\\201c';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -35%);
    color: ${colors.marigold};
    font-size: 100px;
    font-weight: 700;
    line-height: 1;
  }
`;

export default BlockquoteBlock;
